module.exports = __webpack_public_path__ + "img/border_Ring.84d9b68c.svg";